<template>
  <div class="content-item">
    <!-- Drag Handle -->
    <div class="drag-handle">
      <v-img class="handle" src="/static/content-reorder.png"></v-img>
    </div>
    <!-- Content Info (Icon, Title, Description) -->
    <div class="content-info">
      <div class="file-icon">
        <v-icon class="" color="primary">{{ icon }}</v-icon>
      </div>
      <div>
        <h3 class="content-title">{{ item.title }}</h3>
        <p class="content-description">{{ item.description }}</p>
      </div>
    </div>
    <!-- Actions (Edit & Delete Buttons) -->
    <div class="actions">
      <v-btn v-if="['fa-file-word', 'fa-file', 'fa-file-pdf'].includes(icon)" small outlined class="edit-btn"
        @click="showEditDocumentPanel()">
        Edit
      </v-btn>
      <v-btn class="delete-btn" style="background: transparent; box-shadow: none;" @click="removeAsset()" :ripple="false">
        <i class="fa-solid fa-trash-xmark"></i>
      </v-btn>
    </div>
  </div>

</template>
<script>
import courseAPI from '@/api/course.js';
import EditDocument from '@/components/admin/course/trainingmaterial/EditDocument';
export default {
  name: 'SortCourseMaterialListItem',
  props: {
    item: {
      type: Object,
      default: null,
    },
    id: {
      type: String,
      default: null,
    },
    index: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      confirmDelete:
        'Are you sure you want to delete this content from your course?',
    };
  },
  computed: {
    mimeType() {
      return this.item.file
        ? this.item.file.hasOwnProperty('data')
          ? this.item.file.data.mime_type
          : this.item.file.mime_type
        : 'link';
    },
    icon() {
      var item = '';
      switch (this.mimeType) {
        case 'link':
          item = 'fa-link';
          break;
        case 'video/mp4':
          item = 'fa-video';
          break;
        case 'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
          item = 'fa-file-word';
          break;
        case 'application/vnd.openxmlformats-officedocument.presentationml.presentation':
          item = 'fa-file-ppt';
          break;
        case 'application/pdf':
          item = 'fa-file-pdf';
          break;
        case 'application/x-zip-compressed':
          item = 'fa-photo-film-music';
          break;
        case 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet':
          item = 'fa-file-spreadsheet';
          break;
        default:
          item = 'fa-file';
          break;
      }
      return item;
    },
  },
  methods: {
    removeAsset() {
      this.$snotify.confirm(this.confirmDelete, {
        backdrop:0.3,                         
        buttons: [
		  { text: 'Cancel',className: 'toast-cancel-button'},
          {
            text: 'Continue',
            className: 'toast-continue-button',
            action: (toast) => this.processRemoveAsset(toast, this.id),
          }         
        ],
      });
    },
    processRemoveAsset(toast, id) {
      this.$snotify.remove(toast.id);
      courseAPI.removeCourseMaterial(this.id, this.item.id).then(() => {
        this.$store.dispatch('removeCourseMaterials', this.index);
      });
    },
    showEditDocumentPanel() {
      this.$showPanel({
        component: EditDocument,
        props: {
          id: this.item.id,
          index: this.index,
          item: this.item,
        },
        openOn: 'right',
      });
    },
  },
};
</script>
<style scoped>
.content-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #fff;
  border-radius: 8px;
  padding: 25px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  margin-bottom: 20px;
}

.drag-handle {
  cursor: grab;
  font-size: 24px;
  color: #999;
}

.content-info {
  display: flex;
  flex: 1;
  gap: 10px;
  margin: 0px 45px;
}

.file-icon img {
  width: 24px;
  height: 24px;
}

.content-title {
  font-size: 20px;
  font-weight: 600;
}

.content-description {
  font-size: 14px;
  color: #666;
}

.actions {
  display: flex;
}

.edit-btn {
  background: #616161;
  color: white;
  border-radius: 15px;
  border: none;
  cursor: pointer;
  width: 60px;
  padding: 2px;
}

.delete-btn {
  background: none;
  border: none;
  color: red;
  font-size: 18px;
  cursor: pointer;
  height: auto !important;
  min-width: auto !important;
  padding: 0 0 0 16px !important;
}
.delete-btn::before{
  background-color: transparent;
}
/* Mobile Responsive */
@media (max-width: 768px) {
  .content-item {
    flex-direction: column;
    align-items: flex-start;
    position: relative;
    padding: 20px; /* Adjust padding for better spacing */
  }

  /* Centering the drag icon on the left */
  .drag-handle {
    position: absolute;
    left: 10px;
    top: 50%;
    transform: translateY(-50%);
  }

  /* Ensuring content info has enough left margin to accommodate the drag icon */
  .content-info {
    margin: 0px 20px 20px 45px; 
  }

  /* Positioning the buttons at the bottom-right */
  .actions {
    width: 100%;
    justify-content: flex-end;
    position: absolute;
    bottom: 10px;
    right: 10px;
  }
}
</style>